(async () => {
  const sections = document.querySelectorAll('.featured-collection[data-enabled="true"]');

  for (const el of sections) {
    try {
      const handle = el.getAttribute('data-collection-handle')?.trim();
      const showCount = parseInt(el.getAttribute('data-show'), 10) || 8;
      const grid = el.querySelector('.product-grid');

      // Skip if handle is missing or invalid
      if (!handle || handle === 'null' || handle === 'undefined' || !grid) continue;

      grid.innerHTML = ''; // clear loading placeholder

      // Fetch product count
      let productsCount = 0;
      const meta = await fetch(`/collections/${handle}.json?_=${Date.now()}`, { credentials: 'same-origin' });
      if (meta.ok) {
        const metaJson = await meta.json();
        productsCount = metaJson?.collection?.products_count || 0;
      }

      if (!productsCount) {
        grid.innerHTML = `<li class="grid__item"><div class="color-foreground">${handle} collection not found or empty.</div></li>`;
        continue;
      }

      // Randomly fetch products
      const pageSize = 250;
      const totalPages = Math.ceil(productsCount / pageSize);
      const triedPages = new Set();
      const maxPagesToFetch = Math.min(5, totalPages);
      let pool = [];
      let inStock = [];

      while (triedPages.size < maxPagesToFetch && inStock.length < showCount) {
        let page;
        do {
          page = Math.floor(Math.random() * totalPages) + 1;
        } while (triedPages.has(page));
        triedPages.add(page);

        const res = await fetch(`/collections/${handle}/products.json?limit=${pageSize}&page=${page}&_=${Date.now()}`, {
          credentials: 'same-origin'
        });

        if (res.ok) {
          const json = await res.json();
          const products = json?.products || [];
          pool = pool.concat(products);
          inStock = pool.filter(p => p.variants?.some(v => v.available));
        }
      }

      if (!inStock.length) {
        grid.innerHTML = `<li class="grid__item"><div class="color-foreground">No in-stock products found.</div></li>`;
        continue;
      }

      // Shuffle
      for (let i = inStock.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [inStock[i], inStock[j]] = [inStock[j], inStock[i]];
      }

      const selected = inStock.slice(0, showCount);

      // Render product cards
      const htmlParts = await Promise.all(
        selected.map(async (p) => {
          const r = await fetch(`/products/${p.handle}?view=rv-card`, { credentials: 'same-origin' });
          if (!r.ok) return '';
          const cardHtml = await r.text();
          return `<li class="grid__item grid__slide">${cardHtml}</li>`;
        })
      );

      const finalHtml = htmlParts.filter(Boolean).join('');
      grid.innerHTML = finalHtml || `<li class="grid__item"><div class="color-foreground">Could not render product cards.</div></li>`;

      // --- Reinitialize theme and images ---
      if (typeof lazySizes !== 'undefined' && typeof lazySizes.init === 'function') {
        lazySizes.init();
      }

      if (typeof theme !== 'undefined') {
        if (typeof theme.initObservers === 'function') theme.initObservers();
        if (typeof theme.initQuickShop === 'function') theme.initQuickShop();
        if (typeof theme.initProductCard === 'function') theme.initProductCard();
      }

      document.querySelectorAll('img[data-src]').forEach(img => {
        if (!img.src) img.src = img.getAttribute('data-src');
      });

      if (typeof Shopify !== 'undefined' && typeof Shopify.bindEvents === 'function') {
        Shopify.bindEvents();
      }

    } catch (e) {
      console.error('Featured Collection error:', e);
      const grid = el?.querySelector?.('.grid.product-grid');
      if (grid) {
        grid.innerHTML = `<li class="grid__item"><div class="color-foreground">Something went wrong loading products.</div></li>`;
      }
    }
  }
})();
